import {
  Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
} from '@triare/auth-redux';
import {
  put, delay, takeLatest, call,
} from 'redux-saga/effects';
import { actions, SubCategoryStatus } from './index';
import { SubCategoryCreateBody } from './create';

export type SubCategoryUpdateData = {
  success: boolean;
};

export type SubCategoryUpdateResponse = SubCategoryUpdateData;

export interface SubCategoryUpdateBody extends Partial<SubCategoryCreateBody> {
  status?: SubCategoryStatus;
}

export interface SubCategoryUpdatePayload {
  id: string;
  body: SubCategoryUpdateBody
}

export const subCategoryUpdate = (payload: SubCategoryUpdatePayload): Action<SubCategoryUpdatePayload> => ({
  type: actions.subCategoryUpdateTrigger.toString(),
  payload,
});

export const subCategoryUpdateClear = (): Action => ({
  type: actions.subCategoryUpdateClear.toString(),
});

export const subCategoryUpdateErrorClear = (): Action => ({
  type: actions.subCategoryUpdateErrorReset.toString(),
});

export function* subCategoryUpdateRequestSaga({ payload }: Action<SubCategoryUpdatePayload>) {
  yield put({
    type: actions.subCategoryUpdateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.subCategoryUpdateError.toString(),
      payload: {
        message: 'SubCategoryUpdate: Parameters not passed.',
      },
    });

    return;
  }

  const { id, body } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}sub-categories/${id}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<SubCategoryUpdateData, SubCategoryUpdateResponse>(
    response,
    actions.subCategoryUpdateSuccess.toString(),
    actions.subCategoryUpdateError.toString(),
    false,
    (subCategoryUpdateData) => subCategoryUpdateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.subCategoryUpdateTrigger.toString(),
    defaultProcessingSaga(
      subCategoryUpdateRequestSaga,
      {
        error: actions.subCategoryUpdateError.toString(),
        locationCancel: actions.subCategoryUpdateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.subCategoryUpdateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.subCategoryUpdateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.subCategoryUpdateErrorReset.toString(),
    });
  });
}
